import { Component, OnInit, OnChanges, TemplateRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { first } from 'rxjs';
import { User } from 'src/app/models/user';
import { AutomationService } from 'src/app/services/automation.service';
import { CommonService } from 'src/app/services/common.service';
import { DevicesService } from 'src/app/services/devices.service';
import { GroupsService } from 'src/app/services/groups.service';
import { LoginService } from 'src/app/services/login.service';
import { SettingsService } from 'src/app/services/settings.service';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import moment from 'moment';
import { group } from '@angular/animations';
import { LogsComponent } from 'src/app/control/logs/logs.component';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { HostListener } from '@angular/core';
import { NotifyUserUpdation } from 'src/app/services/notify-user-creation.service';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SortPipe } from 'src/app/sort.pipe';
import { SearchPipe } from 'src/app/search.pipe';
import { NgxPaginationModule, PaginatePipe } from 'ngx-pagination';
import { PaginationComponent } from 'src/app/helpers/pagination/pagination.component';

interface Browser {
  id: string;
  browser: string;
  browserVersion: string;
  os: string;
  ip: string;
  port: number;
  username: string;
  accessUrl: string;
  automationUrl: string;
  automationPort: number;
  ngasa_url: string;
  selected?: boolean;
}
interface GroupState {
  showGroupBrowsers: boolean;
  showAvailableBrowsers: boolean;
  showBrowserGrpMenu: boolean;
  showBrowserAvlMenu: boolean;
  browserSearch: string;
  availableBrowserSearch: string;
  browserCurrentPage: number;
  availableBrowserCurrentPage: number;
  groupBrowserPageSize: number;
  availableBrowserPageSize: number;
  groupBrowsers: Browser[];
  availableBrowsers: Browser[];
  sortFieldGrpBrowsers: string;
  sortDirectionGrpBrowsers: string;
  sortFieldAvlBrowsers: string;
  sortDirectionAvlBrowsers: string;
}
@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.css'],
  standalone: true,
  imports: [TranslateModule, CommonModule, PaginationComponent, NgxPaginationModule, FormsModule, SortPipe, SearchPipe]
})
export class GroupComponent implements OnInit, OnChanges, OnDestroy {
  private userCreatedSubscription: Subscription;
  private userDeletedSubscription: Subscription;
  displayedGroups: any[] = [];
  sortOrder = 'asc';
  currentColumn = '';
  sortFieldAvlDevices: string = "columnName";
  sortDirectionAvlDevices: string = 'asc';
  sortFieldGrpDevices: string = "columnName";
  sortDirectionGrpDevices: string = 'asc';
  @ViewChild('alert_message') alertTemplate: TemplateRef<any>;

  @ViewChild('remove_group') removeGroupTemplate: TemplateRef<any>
  alertMessage: any;
  disableDropdown: boolean = false;
  disableSavebutton: boolean = true;
  hiddenGetReady: boolean = false;
  Defaultvalue: 'once'
  groupsPageSize: any;
  groupsUserPageSize: any;
  availableUserPageSize: any;
  groupDevicePageSize: any;
  availableDevicePageSize: any;
  removeGroupId: any;
  search: any;
  groupId: any;
  filteredGroups: any;
  deviceSearch: any;
  availableDeviceSearch: any;
  groupUserSearch: any;
  userSearch: any;
  availableUserSearch: any;
  currentPage: number = 1;
  userCurrentPage: any;
  availableUserCurrentPage: any;
  deviceCurrentPage: any;
  availableDeviceCurrentPage: any;
  confirmRemove = { value: true };
  showGrpMenu: boolean = false;
  showAvlMenu: boolean = false;
  showBrowsers = false;
  showGroupBrowsers = false;
  showAvailableBrowsers = false;
  showBrowserGrpMenu = false;
  showBrowserAvlMenu = false;
  groupstandardizableBrowsersList: Browser[] = [];
  groupAvailablestandardizableBrowsersList: Browser[] = [];
  groupBrowserPageSize = 10;
  availableBrowserPageSize = 10;
  browserCurrentPage = 1;
  availableBrowserCurrentPage = 1;
  browserSearch = '';
  availableBrowserSearch = '';
  sortFieldGrpBrowsers = '';
  sortDirectionGrpBrowsers = '';
  sortFieldAvlBrowsers = '';
  sortDirectionAvlBrowsers = '';
  itemsPerPageOptions = [
    { name: '1', value: 1 }
    , { name: '5', value: 5 }
    , { name: '10', value: 10 }
    , { name: '20', value: 20 }
    , { name: '50', value: 50 }
    , { name: '100', value: 100 }
    , { name: '200', value: 200 }
    , { name: '500', value: 500 }
    , { name: '1000', value: 1000 }
    , { name: '*', value: 0 }
  ];
  defaultBrowserData: any = {
    columns: [
      { name: 'ID', selected: true, sort: 'sort-asc' },
      { name: 'Browser', selected: true, sort: 'none' },
      { name: 'Browser Version', selected: true, sort: 'none' },
      { name: 'OS', selected: true, sort: 'none' },
      { name: 'IP', selected: true, sort: 'none' },
      { name: 'Port', selected: true, sort: 'none' },
      { name: 'Username', selected: true, sort: 'none' },
      { name: 'Access URL', selected: false, sort: 'none' },
      { name: 'Automation URL', selected: false, sort: 'none' },
      { name: 'Automation Port', selected: false, sort: 'none' },
      { name: 'NGASA URL', selected: false, sort: 'none' }
    ],
    sort: { class: '', index: 0, reverse: false }
  };

  browserData = { ...this.defaultBrowserData };
  groupStates: { [groupId: string]: GroupState } = {};

  deviceData: any;
  groupDeviceData: any
  hideGroupCreation: boolean = false;
  setDeviceLimitOfGroup: any = '';
  setName: any = '';
  originDevices: any[] = [];
  originDevicesBySerial: any = {};
  standardizableDevices: any[] = [];
  standardizableDevicesBySerial: any = {};
  groupsById: any = {};
  cachedGroupsClass: any = {};
  deviceFields: any =
    'serial,' +
    'model,' +
    'version,' +
    'operator,' +
    'network.type,' +
    'network.subtype,' +
    'display.height,' +
    'display.width,' +
    'manufacturer,' +
    'sdk,' +
    'abi,' +
    'cpuPlatform,' +
    'openGLESVersion,' +
    'marketName,' +
    'phone.imei,' +
    'provider.name,' +
    'group.originName';

  userFields: any =
    'email,' +
    'name,' +
    'privilege,' +
    'groups.subscribed,' +
    'groups.quotas.allocated,' +
    'groups.quotas.consumed';

  rootGroupId: any;

  currentUser: User;
  scopeGroupsCtrl = this;
  users: any[] = [];
  availableUserList: any[] = [];
  groupUserList: any[] = [];
  usersByEmail: any = {};
  groups: any[] = [];
  groupsEnv: any = {};
  groupstandardizableDevicesList: any[] = [];
  groupAvailablestandardizableDevicesList: any[] = [];

  userColumns = [
    { name: 'Name', property: 'name' }
    , { name: 'Email', property: 'email' }
    , { name: 'Privilege', property: 'privilege' }
  ];

  defaultUserData = {
    columns: [
      { name: 'Name', sort: 'sort-asc' }
      , { name: 'Email', sort: 'none' }
      , { name: 'Privilege', sort: 'none' }
    ]
    , sort: { index: 0, reverse: false }
  };

  conflictColumns = [
    { name: 'Serial', property: 'serial' }
    , { name: 'Starting Date', property: 'startDate' }
    , { name: 'Expiration Date', property: 'stopDate' }
    , { name: 'Group Name', property: 'group' }
    , { name: 'Group Owner', property: 'ownerName' }
  ];

  defaultConflictData = {
    columns: [
      { name: 'Serial', sort: 'sort-asc' }
      , { name: 'Starting Date', sort: 'none' }
      , { name: 'Expiration Date', sort: 'none' }
      , { name: 'Group Name', sort: 'none' }
      , { name: 'Group Owner', sort: 'none' }
    ]
    , sort: { index: 0, reverse: false }
  };

  deviceColumns = [
    { name: 'Model', property: 'model' }
    , { name: 'Serial', property: 'serial' }
    , { name: 'Carrier', property: 'operator' }
    , { name: 'OS', property: 'version' }
    , { name: 'Network', property: this.computeNetwork }
    , { name: 'Screen', property: this.computeDisplay }
    , { name: 'Manufacturer', property: 'manufacturer' }
    , { name: 'SDK', property: 'sdk' }
    , { name: 'ABI', property: 'abi' }
    , { name: 'CPU Platform', property: 'cpuPlatform' }
    , { name: 'OpenGL ES version', property: 'openGLESVersion' }
    , { name: 'Market name', property: 'marketName' }
    , { name: 'Phone IMEI', property: 'phone.imei' }
    , { name: 'Location', property: 'provider.name' }
    , { name: 'Group Origin', property: 'group.originName' }
  ]

  defaultDeviceData = {
    columns: [
      { name: 'Model', selected: true, sort: 'none' }
      , { name: 'Serial', selected: true, sort: 'none' }
      , { name: 'Carrier', selected: false, sort: 'none' }
      , { name: 'OS', selected: true, sort: 'none' }
      , { name: 'Network', selected: false, sort: 'none' }
      , { name: 'Screen', selected: true, sort: 'none' }
      , { name: 'Manufacturer', selected: true, sort: 'none' }
      , { name: 'SDK', selected: true, sort: 'none' }
      , { name: 'ABI', selected: false, sort: 'none' }
      , { name: 'CPU Platform', selected: false, sort: 'none' }
      , { name: 'OpenGL ES version', selected: false, sort: 'none' }
      , { name: 'Market name', selected: true, sort: 'none' }
      , { name: 'Phone IMEI', selected: false, sort: 'none' }
      , { name: 'Location', selected: true, sort: 'none' }
      , { name: 'Group Origin', selected: true, sort: 'none' }
    ]
    , sort: { index: 0, reverse: false, class: '' }
  }
  private initializeGroupState(groupId: string): GroupState {
    if (!this.groupStates[groupId]) {
      this.groupStates[groupId] = {
        showGroupBrowsers: false,
        showAvailableBrowsers: false,
        showBrowserGrpMenu: false,
        showBrowserAvlMenu: false,
        browserSearch: '',
        availableBrowserSearch: '',
        browserCurrentPage: 1,
        availableBrowserCurrentPage: 1,
        groupBrowserPageSize: 10,
        availableBrowserPageSize: 10,
        groupBrowsers: [],
        availableBrowsers: [],
        sortFieldGrpBrowsers: 'id',
        sortDirectionGrpBrowsers: 'asc',
        sortFieldAvlBrowsers: 'id',
        sortDirectionAvlBrowsers: 'asc'
      };
    }

    return this.groupStates[groupId];
  }
  getGroupState(groupId: string): GroupState {
    return this.initializeGroupState(groupId);
  }


  nameRegex: any = /^[0-9a-zA-Z-_./: ]{1,50}$/
  nameRegexStr: any = '/^[0-9a-zA-Z-_./: ]{1,50}$/'
  classOptions: any;
  getClassName: any;

  //boolean
  showName: boolean = false;
  showUsers: boolean = false;
  showDevices: boolean = false;
  showSchedule: boolean = false;
  showAvailableDevices: boolean = false;
  showAvailableUsers: boolean = false;
  showGroupUsers: boolean = false;
  showGroupDevices: boolean = false;
  showDeviceLimit: boolean = false;

  dValue: any

  //Modal
  modalRef!: MatDialogRef<any>;


  constructor(
    private router: Router,
    private dialog: MatDialog,
    private automationService: AutomationService,
    private groupsService: GroupsService,
    private commonService: CommonService,
    private usersService: UserService,
    private devicesService: DevicesService,
    private loginService: LoginService,
    private settingsService: SettingsService,
    private notifyUserUpdation: NotifyUserUpdation
  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);

    this.classOptions = this.commonService.classOptions;
    this.getClassName = this.commonService.getClassName;

    this.settingsService.bind(this, {
      target: 'groupItemsPerPage'
      , source: 'groupItemsPerPage'
      , defaultValue: this.itemsPerPageOptions[2]
    })

    this.settingsService.bind(this, {
      target: 'userData'
      , source: 'userData'
      , defaultValue: this.defaultUserData
    })

    this.settingsService.bind(this, {
      target: 'groupUserData'
      , source: 'groupUserData'
      , defaultValue: this.defaultUserData
    })

    this.settingsService.bind(this, {
      target: 'conflictData'
      , source: 'conflictData'
      , defaultValue: this.defaultConflictData
    })

    this.settingsService.bind(this, {
      target: 'deviceData'
      , source: 'deviceData'
      , defaultValue: this.defaultDeviceData
    })

    this.settingsService.bind(this, {
      target: 'groupDeviceData'
      , source: 'groupDeviceData'
      , defaultValue: this.defaultDeviceData
    })
  }
  ngOnDestroy(): void {
    if (this.userCreatedSubscription) {
      this.userCreatedSubscription.unsubscribe();
    }
    if (this.userDeletedSubscription) {
      this.userDeletedSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.groupsPageSize = 10;
    this.groupsUserPageSize = 10;
    this.availableUserPageSize = 10;
    this.groupDevicePageSize = 10;
    this.availableDevicePageSize = 10;
    this.currentPage = 1;
    this.userCurrentPage = 1;
    this.availableUserCurrentPage = 1;
    this.deviceCurrentPage = 1;
    this.availableDeviceCurrentPage = 1;
    this.initScope();
    // Subscribe to the user created event
    this.userCreatedSubscription = this.notifyUserUpdation.userCreated$.subscribe(userData => {
      this.initScope();
      let group = this.groups.filter(group => group.name == 'Common')
      this.addGroupUser(group[0], userData)
    });
    // Subscribe to the user deleted event
    this.userDeletedSubscription = this.notifyUserUpdation.userDeleted$.subscribe(userData => {
      let groupWhereUserIsPresent = [];
      for (let i = 0; i < this.groups.length; i++) {
        const group = this.groups[i];
        if (group.users.includes(userData.email)) {
          groupWhereUserIsPresent.push(group);
        }
      }
      for (let group in groupWhereUserIsPresent)
        this.removeGroupUser(groupWhereUserIsPresent[group], userData);
      this.initScope();
    });
  }

  ngOnChanges() {
    this.initScope();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const dropdownElement = (event.target as HTMLElement).closest('.pull-left');
    if (!dropdownElement) {
      this.showGrpMenu = false;
      this.showAvlMenu = false;
    }
  }

  //customize functionality
  showGrpmenu() {
    if (this.showGrpMenu) {
      this.showGrpMenu = false
    } else {
      this.showGrpMenu = true
    }
  }

  showAvlmenu() {
    if (this.showAvlMenu) {
      this.showAvlMenu = false
    } else {
      this.showAvlMenu = true
    }
  }

  resetData() {
    this.defaultDeviceData.columns = [
      { name: 'Model', selected: true, sort: 'sort-asc' }
      , { name: 'Serial', selected: true, sort: 'none' }
      , { name: 'Carrier', selected: false, sort: 'none' }
      , { name: 'OS', selected: true, sort: 'none' }
      , { name: 'Network', selected: false, sort: 'none' }
      , { name: 'Screen', selected: true, sort: 'none' }
      , { name: 'Manufacturer', selected: true, sort: 'none' }
      , { name: 'SDK', selected: true, sort: 'none' }
      , { name: 'ABI', selected: false, sort: 'none' }
      , { name: 'CPU Platform', selected: false, sort: 'none' }
      , { name: 'OpenGL ES version', selected: false, sort: 'none' }
      , { name: 'Market name', selected: true, sort: 'none' }
      , { name: 'Phone IMEI', selected: false, sort: 'none' }
      , { name: 'Location', selected: true, sort: 'none' }
      , { name: 'Group Origin', selected: true, sort: 'none' }
    ]
  }

  // sortBy(data: any, column: any) {
  //   return this.commonService.sortBy(data, column);
  // }
  sortByAvailableDevices(data, column) {
    const index = this.getIndex(data.columns, column.name, 'name');

    if (index !== data.sort.index) {
      data.sort.reverse = false;
      column.sort = 'sort-asc';
      data.columns[data.sort.index].sort = 'none';
      data.sort.index = index;
    } else {
      data.sort.reverse = !data.sort.reverse;
      column.sort = column.sort === 'sort-asc' ? 'sort-desc' : 'sort-asc';
    }

    switch (column.name) {
      case "CPU Platform":
        this.sortFieldAvlDevices = "cpuPlatform";
        break;
      case "Carrier":
        this.sortFieldAvlDevices = "operator";
        break;
      case "OS":
        this.sortFieldAvlDevices = "version";
        break;
      case "network":
        this.sortFieldAvlDevices = "network";
        break;
      case "Screen":
        this.sortFieldAvlDevices = "displayStr";
        break;
      case "OpenGL ES version":
        this.sortFieldAvlDevices = "OpenGLESVersion";
        break;
      case "Market name":
        this.sortFieldAvlDevices = "marketName";
        break;
      case "Phone IMEI":
        this.sortFieldAvlDevices = "phone";
        break;
      case "Location":
        this.sortFieldAvlDevices = "provider";
        break;
      case "Group Origin":
        this.sortFieldAvlDevices = "group";
        break;
      default:
        this.sortFieldAvlDevices = column.name.toLowerCase();
    }
    this.defaultDeviceData.sort.class = 'avl';
    this.sortDirectionAvlDevices = column.sort === 'sort-asc' ? 'asc' : 'desc';

  }

  sortByGroupDevices(data, column) {


    const index = this.getIndex(data.columns, column.name, 'name');

    if (index !== data.sort.index) {
      data.sort.reverse = false;
      column.sort = 'sort-asc';
      data.columns[data.sort.index].sort = 'none';
      data.sort.index = index;
    } else {
      data.sort.reverse = !data.sort.reverse;
      column.sort = column.sort === 'sort-asc' ? 'sort-desc' : 'sort-asc';
    }
    switch (column.name) {
      case "CPU Platform":
        this.sortFieldGrpDevices = "cpuPlatform";
        break;
      case "Carrier":
        this.sortFieldGrpDevices = "operator";
        break;
      case "OS":
        this.sortFieldGrpDevices = "version";
        break;
      case "network":
        this.sortFieldGrpDevices = "network";
        break;
      case "Screen":
        this.sortFieldGrpDevices = "displayStr";
        break;
      case "OpenGL ES version":
        this.sortFieldGrpDevices = "OpenGLESVersion";
        break;
      case "Market name":
        this.sortFieldGrpDevices = "marketName";
        break;
      case "Phone IMEI":
        this.sortFieldGrpDevices = "phone";
        break;
      case "Location":
        this.sortFieldGrpDevices = "provider";
        break;
      case "Group Origin":
        this.sortFieldGrpDevices = "group";
        break;
      default:
        this.sortFieldGrpDevices = column.name.toLowerCase();
    }
    this.defaultDeviceData.sort.class = 'grp';
    this.sortDirectionGrpDevices = column.sort === 'sort-asc' ? 'asc' : 'desc';

  }

  getIndex(array, value, property) {
    for (let i in array) {
      if (array[i][property] === value) {
        return i
      }
    }
    return -1
  }
  onColumnClick(columnName: string) {
    if (this.currentColumn === columnName) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortOrder = 'asc';
      this.currentColumn = columnName;
    }

    this.groupUserList = this.sortByColumn(this.groupUserList, columnName, this.sortOrder);
  }
  onColumnClickAvlUsers(columnName: string) {
    if (this.currentColumn === columnName) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortOrder = 'asc';
      this.currentColumn = columnName;
    }

    this.availableUserList = this.sortByColumn(this.availableUserList, columnName, this.sortOrder);
  }
  sortByColumn(data: any[], columnName: string, sortOrder: string): any[] {
    return data.sort((a, b) => {
      let valueA = a[columnName];
      let valueB = b[columnName];

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        valueA = valueA.toLowerCase();
        valueB = valueB.toLowerCase();
      }

      if (valueA < valueB) {
        return sortOrder === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return sortOrder === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
  }


  onNextPageChange(nextPage: number) {
    this.currentPage = nextPage;
  }

  onItemPerPageChange(changedItemPerPage: number) {
    this.groupsPageSize = changedItemPerPage;
    this.currentPage = 1;
  }

  onSearch(searchData: string) {
    this.search = searchData;
    this.currentPage = 1;
  }

  onUserSearch(searchData: any) {
    this.userSearch = searchData;
    this.userCurrentPage = 1;
  }

  onUserItemPerPageChange(changedItemPerPage: any) {
    this.groupsUserPageSize = changedItemPerPage;
    this.userCurrentPage = 1;
  }

  onNextUserPageChange(nextPage: number) {
    this.userCurrentPage = nextPage;
  }

  onAvailableUserSearch(searchData: any) {
    this.availableUserSearch = searchData;
    this.availableUserCurrentPage = 1;
  }

  onAvailableUserItemPerPageChange(changedItemPerPage: any) {
    this.availableUserPageSize = changedItemPerPage;
    this.availableUserCurrentPage = 1;
  }

  onNextAvailableUserPageChange(nextPage: number) {
    this.availableUserCurrentPage = nextPage;
  }

  onDeviceSearch(searchData: any) {
    this.deviceSearch = searchData;
    this.deviceCurrentPage = 1;
  }

  onDeviceItemPerPageChange(changedItemPerPage: any) {
    this.groupDevicePageSize = changedItemPerPage;
    this.deviceCurrentPage = 1;
  }

  onNextDevicePageChange(nextPage: number) {
    this.deviceCurrentPage = nextPage;
  }

  onAvailableDeviceSearch(searchData: any) {
    this.availableDeviceSearch = searchData;
    this.availableDeviceCurrentPage = 1;
  }

  onAvailableDeviceItemPerPageChange(changedItemPerPage: any) {
    this.availableDevicePageSize = changedItemPerPage;
    this.availableDeviceCurrentPage = 1;
  }

  onNextAvailableDevicePageChange(nextPage: number) {
    this.availableDeviceCurrentPage = nextPage;
  }

  publishDevice(device: any) {
    if (!device.model) {
      device.display = device.phone = device.network = {};
    }
    else {
      device.displayStr = device.display.width + 'x' + device.display.height;
      device.networkStr = this.computeNetwork(device);
    }
    return device
  }

  initAvailableGroupDevices(group: any, availableDevices: any, availableDevicesBySerial: any) {
    this.groupsEnv[group.id].availableDevices = availableDevices;
    this.groupsEnv[group.id].availableDevicesBySerial = availableDevicesBySerial;

    this.groupsEnv[group.id].availableDevices.forEach((device: any) => {
      this.publishDevice(device);
    })
  }

  setDeviceLimit(groupId: any, updateDeviceCount: any) {
    //to be fixed in next build
    if (updateDeviceCount % 1 == 0 && updateDeviceCount >= 2) {
      // this.automationService.updateDeviceLimit(groupId, updateDeviceCount).pipe(first()).subscribe((res: any) => {
      // if (res.success === true || res.success === "true") {
      this.openAlertMod(this.alertTemplate, "Successfully Updated");
      // } else {
      // this.openAlertMod(this.alertTemplate, "Oops, Something Went Wrong!");
      // }
      // });
    }
    else {
      this.openAlertMod(this.alertTemplate, "Please enter a whole number >=2. Decimal values are invalid.")
    }

  }

  checkDeviceLimit(groupId: any, groupName: any) {
    this.setName = groupName;
    const groupNameStore = groupName;

    this.automationService.checkDeviceLimitOfgroup(groupId, groupName).pipe(first()).subscribe((res: any) => {
      this.dValue = res;
    })
  }

  getAvailableGroupDevices(group: any) {
    if (group.class === 'bookable') {
      this.initAvailableGroupDevices(group, this.originDevices, this.originDevicesBySerial);
    }
    else if (group.class === 'standard') {
      this.initAvailableGroupDevices(group, this.standardizableDevices, this.standardizableDevicesBySerial)
    }
    else if (this.groupsEnv[group.id].showDevices) {
      this.groupsService.getGroupDevices(group.id, true, this.deviceFields).pipe(first()).subscribe((response: any) => {
        if (response.success == true || response.success == true) {
          if (this.commonService.isExisting(this.groupsEnv[group.id])) {
            this.groupsEnv[group.id].availableDevicesBySerial = {}
            this.groupsEnv[group.id].availableDevices = []
            response.devices.forEach((device: any) => {
              this.addAvailableGroupDevice(group.id, device, -1)
            })
            this.initAvailableGroupDevices(
              group
              , this.groupsEnv[group.id].availableDevices
              , this.groupsEnv[group.id].availableDevicesBySerial)
          }
        }
      });
    }
  }

  checkDurationQuota(group: any, deviceNumber: any, startDate: any, stopDate: any, repetitions: any) {
    if (this.commonService.isOriginGroup(group.class)) {
      return true
    }
    if (this.commonService.isExisting(this.usersByEmail[group.owner.email])) {
      const duration =
        (group.devices.length + deviceNumber) *
        (new Date(stopDate).getTime() - new Date(startDate).getTime()) *
        (repetitions + 1)

      if (duration <=
        this.users[this.usersByEmail[group.owner.email].index]
          .groups.quotas.allocated.duration) {
        return true
      }
    }
    return false
  }

  isBookedDevice(serial: any) {
    if (this.commonService.isExisting(this.originDevicesBySerial[serial])) {
      for (let i in this.groups) {
        if (!this.commonService.isOriginGroup(this.groups[i].class) &&
          this.groups[i].devices.indexOf(serial) > -1) {
          return true
        }
      }
    }
    return false
  }

  addStandardizableDevicesIfNotBooked(devices: any, timeStamp: any) {
    devices.forEach((serial: any) => {
      if (!this.isBookedDevice(serial)) {
        this.addStandardizableDevice(
          this.originDevices[this.originDevicesBySerial[serial].index]
          , timeStamp
        )
      }
    })
  }

  updateStandardizableDeviceIfNotBooked(device: any, timeStamp: any) {
    if (!this.isBookedDevice(device.serial)) {
      this.updateStandardizableDevice(device, timeStamp)
    }
  }

  initGroup(group: any) {
    this.cachedGroupsClass[group.id] = group.class
    if (typeof this.groupsEnv[group.id] === 'undefined') {
      this.groupsEnv[group.id] = {}
      this.initAvailableGroupDevices(group, [], {})
      if (group.privilege === 'root') {
        this.rootGroupId = group.id
      }
    }
    return group
  }

  addGroup(group: any, timeStamp: any) {
    if (this.commonService.add(this.groups, this.groupsById, group, 'id', timeStamp)) {
      return this.initGroup(group);
    }
    return null
  }

  updateGroup(group: any, timeStamp: any, noAdding?: any) {



    if (this.commonService.update(this.groups, this.groupsById, group, 'id', timeStamp, noAdding)) {
      return this.initGroup(this.groups[this.groupsById[group.id].index]);
    }
    return null
  }

  deleteGroup(id: any, timeStamp: any) {
    const group = this.commonService.delete(this.groups, this.groupsById, id, timeStamp)
    if (group) {
      delete this.groupsEnv[group.id]
    }
    return group
  }

  addOriginDevice(device: any, timeStamp: any) {


    return this.commonService.add(this.originDevices, this.originDevicesBySerial, device, 'serial', timeStamp)
  }

  updateOriginDevice(device: any, timeStamp: any) {
    return this.commonService.update(this.originDevices, this.originDevicesBySerial, device, 'serial', timeStamp)
  }

  deleteOriginDevice(serial: any, timeStamp: any) {
    return this.commonService.delete(this.originDevices, this.originDevicesBySerial, serial, timeStamp)
  }

  addStandardizableDevice(device: any, timeStamp: any) {


    return this.commonService.add(
      this.standardizableDevices, this.standardizableDevicesBySerial, device, 'serial', timeStamp)
  }

  updateStandardizableDevice(device: any, timeStamp: any) {
    return this.commonService.update(
      this.standardizableDevices, this.standardizableDevicesBySerial, device, 'serial', timeStamp)
  }

  deleteStandardizableDevice(serial: any, timeStamp: any) {
    return this.commonService.delete(
      this.standardizableDevices, this.standardizableDevicesBySerial, serial, timeStamp)
  }

  addAvailableGroupDevice(id: any, device: any, timeStamp: any) {
    return this.commonService.add(
      this.groupsEnv[id].availableDevices
      , this.groupsEnv[id].availableDevicesBySerial, device, 'serial', timeStamp)
  }

  updateAvailableGroupDevice(id: any, device: any, timeStamp: any, noAdding: any) {
    return this.commonService.update(
      this.groupsEnv[id].availableDevices
      , this.groupsEnv[id].availableDevicesBySerial, device, 'serial', timeStamp, noAdding)
  }

  deleteAvailableGroupDevice(id: any, serial: any, timeStamp: any) {
    return this.commonService.delete(
      this.groupsEnv[id].availableDevices
      , this.groupsEnv[id].availableDevicesBySerial, serial, timeStamp)
  }

  addUser(user: any, timeStamp: any) {
    return this.commonService.add(this.users, this.usersByEmail, user, 'email', timeStamp);
  }

  updateUser(user: any, timeStamp: any) {
    return this.commonService.update(this.users, this.usersByEmail, user, 'email', timeStamp);
  }

  deleteUser(email: any, timeStamp: any) {

    return this.commonService.delete(this.groups, this.groupsById, email, timeStamp);
    // CommonService.delete($scope.groups, groupsById, id, timeStamp)

  }

  initScope() {
    this.groupsService.getOboeMyGroups(null).pipe(first()).subscribe((res: any) => {
      if (res.success == true || res.success == "true") {
        res.groups.forEach((group: any) => {
          this.addGroup(group, -1)
        })
      }
    })



    // this.groupsService.getOboeMyGroups((group) => {
    //   this.addGroup(group, -1)
    // })
    // .done(() => {
    //   $scope.$digest()
    // })

    // this.usersService.getOboeUsers(this.userFields, (user :any) => {
    //   this.addUser(user, -1)
    // })
    // .done(() => {
    //   if (this.commonService.isExisting(this.usersByEmail[this.currentUser.email])) {
    //     this.users[this.usersByEmail[this.currentUser.email].index] = this.currentUser;
    //   }
    // })

    this.usersService.getOboeUsers(this.userFields, null).pipe(first()).subscribe({
      next: (res: any) => {
        if (res.success == true || res.success == "true") {
          res.users.forEach((user: any) => {
            this.addUser(user, -1)
          });
        }
      },
      complete: () => {
        if (this.commonService.isExisting(this.usersByEmail[this.currentUser.email])) {
          this.users[this.usersByEmail[this.currentUser.email].index] = this.currentUser;
        }
      }
    });

    this.usersService.getUser().pipe(first()).subscribe((response: any) => {
      this.commonService.merge(this.currentUser, response.user);
    });

    if (this.isAdmin()) {
      this.devicesService.getOboeDevices('origin', this.deviceFields).pipe(first()).subscribe((res: any) => {
        if (res.success == true || res.success == "true") {
          res.devices.forEach((device: any) => {
            this.addOriginDevice(device, -1);
          });
        }
      })
      this.devicesService.getOboeDevices('standardizable', this.deviceFields).pipe(first()).subscribe((res: any) => {
        if (res.success == true || res.success == "true") {
          res.devices.forEach((device: any) => {
            this.addStandardizableDevice(device, -1);
          });
        }
      })
      // this.devicesService.getOboeDevices('origin', this.deviceFields, (device :any) => {
      //   this.addOriginDevice(device, -1)
      // })
      // this.devicesService.getOboeDevices('standardizable', this.deviceFields, (device :any) => {
      //   this.addStandardizableDevice(device, -1)
      // })
    }
  }

  mailToGroupOwners(groups: any) {
    this.commonService.copyToClipboard(_.uniq(groups.map((group: any) => {
      return group.owner.email
    })))
    let mail = 'mailto:admin@apmosys.com';
    window.location.href = mail;

    // .join(this.settingsService.get('emailSeparator')))
    // .url('mailto:?body=*** Paste the email addresses from the clipboard! ***')
  }

  mailToGroupUsers(group: any, users: any) {
    this.mailToAvailableUsers(users)
  }

  mailToAvailableUsers(users: any) {
    this.commonService.copyToClipboard(users.map((user: any) => {
      return user.email;
    })
      .join(this.settingsService.get('emailSeparator')))
      .url('mailto:?body=*** Paste the email addresses from the clipboard! ***')
  }

  getGroupIndex(relativeIndex: any) {
    let currentPage = this.page;
    return relativeIndex + (currentPage - 1) * this.groupsPageSize;
  }

  computeDisplay(device: any) {
    return device.display.width * device.display.height
  }

  computeNetwork(device: any) {
    if (!device.network || !device.network.type) {
      return ''
    }
    else if (device.network.subtype) {
      return device.network.type + ' (' + device.network.subtype + ')'
    }
    return device.network.type
  }

  resetDeviceData() {
    this.deviceData = JSON.parse(JSON.stringify(this.defaultDeviceData))
  }

  resetGroupDeviceData() {
    this.groupDeviceData = JSON.parse(JSON.stringify(this.defaultDeviceData))
  }

  isAdmin() {
    return this.currentUser.userObj.privilege === 'admin';
  }

  getRepetitionsQuotas(email: any) {
    if (this.commonService.isExisting(this.usersByEmail[email])) {
      return this.users[this.usersByEmail[email].index].groups.quotas.repetitions
    }
    return null
  }

  initShowDevices(group: any, showDevices: any) {
    if (typeof this.groupsEnv[group.id].groupDeviceCurrentPage === 'undefined') {
      this.groupsEnv[group.id].groupDeviceCurrentPage = 1
      this.groupsEnv[group.id].groupDeviceItemsPerPage = this.itemsPerPageOptions[1]
      this.groupsEnv[group.id].availableDeviceCurrentPage = 1
      this.groupsEnv[group.id].availableDeviceItemsPerPage = this.itemsPerPageOptions[1]
    }

    this.showGroupDevices = false;
    this.showAvailableDevices = false;

    this.groups.forEach((x) => {
      if (x.id == group.id) {
        if (x.isDeviceClicked == true) {
          x.isDeviceClicked = false;
        } else {
          x.isDeviceClicked = true;
        }
      } else {
        x.isDeviceClicked = false;
      }
    });

    this.groupsEnv[group.id].showDevices = showDevices;
    this.getAvailableGroupDevices(group);
  }

  initShowDeviceLimit(group: any) {
    this.groups.forEach((x) => {
      if (x.id == group.id) {
        if (x.isDeviceLimitClicked == true) {
          x.isDeviceLimitClicked = false;
        } else {
          x.isDeviceLimitClicked = true;
        }
      } else {
        x.isDeviceLimitClicked = false;
      }
    });
  }

  initShowUsers(group: any) {
    if (typeof this.groupsEnv[group.id].groupUserCurrentPage === 'undefined') {
      this.groupsEnv[group.id].groupUserCurrentPage = 1
      this.groupsEnv[group.id].groupUserItemsPerPage = this.itemsPerPageOptions[1]
      this.groupsEnv[group.id].availableUserCurrentPage = 1
      this.groupsEnv[group.id].availableUserItemsPerPage = this.itemsPerPageOptions[1]
    }

    this.showGroupUsers = false;
    this.showAvailableUsers = false;

    this.groups.forEach((x) => {
      if (x.id == group.id) {
        if (x.isUserClicked == true) {
          x.isUserClicked = false;
        } else {
          x.isUserClicked = true;
        }
      } else {
        x.isUserClicked = false;
      }
    });
  }

  watchGroupClass(group: any, data: any) {



    if (data.target.value !== 'once') {
      if (group.class !== data.target.value) {
        this.disableSavebutton = false

      }
      else {
        this.disableSavebutton = true

      }
    }
    else {
      this.disableSavebutton = true

    }
    // if(data.target.value === 'once' || group.class === 'once'){
    //   this.disableSavebutton = true

    // }

    if (this.commonService.isNoRepetitionsGroup(this.groupsEnv[group.id].tmpClass)) {
      this.groupsEnv[group.id].tmpRepetitions = 0
    }
    else if (this.groupsEnv[group.id].tmpRepetitions === 0) {
      this.groupsEnv[group.id].tmpRepetitions = 1
    }
  }

  initTemporaryName(group: any) {
    this.groupsEnv[group.id].tmpName = group.name
    this.groupsEnv[group.id].tmpNameTooltip = 'No change'

    this.groups.forEach((x) => {
      if (x.id == group.id) {
        if (x.isNameClicked == true) {
          x.isNameClicked = false;
        } else {
          x.isNameClicked = true;
        }
      } else {
        x.isNameClicked = false;
      }
    });
  }

  initTemporarySchedule(group: any) {



    this.groupsEnv[group.id].tmpClass = group.class
    this.groupsEnv[group.id].tmpRepetitions = group.repetitions
    this.groupsEnv[group.id].tmpStartDate = new Date(group.dates[0].start).toISOString().substring(0, 16)
    this.groupsEnv[group.id].tmpStopDate = new Date(group.dates[0].stop).toISOString().substring(0, 16)


    this.groupsEnv[group.id].tmpScheduleTooltip = 'No change'

    this.groups.forEach((x) => {
      if (x.id == group.id) {
        if (x.isScheduleClicked == true) {
          x.isScheduleClicked = false;
        } else {
          x.isScheduleClicked = true;
        }
      } else {
        x.isScheduleClicked = false;
      }
    });
  }

  conditionForDevicesAddition(group: any, deviceNumber: any) {
    return this.checkDurationQuota(
      group
      , deviceNumber
      , group.dates[0].start
      , group.dates[0].stop
      , group.repetitions
    )
  }

  conditionForGroupCreation() {


    return this.currentUser.userObj.groups.quotas.consumed.number <
      this.currentUser.userObj.groups.quotas.allocated.number
  }

  conditionForGroupUsersRemoving(group: any, users: any) {
    return !(users.length === 0 ||
      group.privilege === 'root' && users.length === 1 && users[0].privilege === 'admin' ||
      group.privilege !== 'root' &&
      (users.length === 2 &&
        (users[0].privilege === 'admin' && users[1].email === group.owner.email ||
          users[0].email === group.owner.email && users[1].privilege === 'admin') ||
        users.length === 1 &&
        (users[0].email === group.owner.email || users[0].privilege === 'admin'))
    )
  }

  conditionForNameSaving(group: any, formInvalidStatus: any) {
    return !formInvalidStatus && this.groupsEnv[group.id].tmpName !== group.name;
  }

  conditionForScheduleSaving(group: any, formInvalidStatus: any) {


    if (formInvalidStatus) {
      this.groupsEnv[group.id].tmpScheduleTooltip = 'Bad syntax'
      return false
    }
    if (this.groupsEnv[group.id].tmpClass !== group.class ||
      parseInt(this.groupsEnv[group.id].tmpRepetitions, 10) !== group.repetitions ||
      this.groupsEnv[group.id].tmpStartDate !==
      (new Date(group.dates[0].start)) ||
      this.groupsEnv[group.id].tmpStopDate !==
      (new Date(group.dates[0].stop))) {
      if (!this.commonService.isNoRepetitionsGroup(this.groupsEnv[group.id].tmpClass)) {
        if (parseInt(this.groupsEnv[group.id].tmpRepetitions, 10) === 0) {
          this.groupsEnv[group.id].tmpScheduleTooltip = 'Repetitions must be > 0 for this Class'
          return false
        }
      }
      if (this.groupsEnv[group.id].tmpStartDate >= this.groupsEnv[group.id].tmpStopDate) {
        this.groupsEnv[group.id].tmpScheduleTooltip = 'Starting date >= Expiration date'
        return false
      }
      if ((this.groupsEnv[group.id].tmpStopDate - this.groupsEnv[group.id].tmpStartDate) >
        this.commonService.getClassDuration(this.groupsEnv[group.id].tmpClass)) {
        this.groupsEnv[group.id].tmpScheduleTooltip =
          '(Expiration date - Starting date) must be <= Class duration'
        return false
      }
      if (this.isAdmin() &&
        group.devices.length &&
        (this.commonService.isOriginGroup(group.class) &&
          !this.commonService.isOriginGroup(this.groupsEnv[group.id].tmpClass) ||
          this.commonService.isOriginGroup(this.groupsEnv[group.id].tmpClass) &&
          !this.commonService.isOriginGroup(group.class))) {
        this.groupsEnv[group.id].tmpScheduleTooltip =
          'Unauthorized class while device list is not empty'
        return false
      }
      if (!this.checkDurationQuota(
        group
        , 0
        , this.groupsEnv[group.id].tmpStartDate
        , this.groupsEnv[group.id].tmpStopDate
        , this.groupsEnv[group.id].tmpRepetitions)) {
        this.groupsEnv[group.id].tmpScheduleTooltip = 'Group duration quotas is reached'
        return false
      }
      this.groupsEnv[group.id].tmpScheduleTooltip = ''
      return true
    }
    this.groupsEnv[group.id].tmpScheduleTooltip = 'No change'
    return false
  }

  conditionForRepetitions(group: any) {
    return !this.commonService.isNoRepetitionsGroup(this.groupsEnv[group.id].tmpClass);
  }

  addGroupDevice(group: any, device: any) {
    if (this.commonService.isOriginGroup(group.class)) {
      this.devicesService.addOriginGroupDevice(group.id, device.serial).pipe(first()).subscribe({
        next: (response: any) => {
          let dummyAarray = this.groupAvailablestandardizableDevicesList.filter(item => item.serial !== response.device.serial)
          this.groupAvailablestandardizableDevicesList = dummyAarray;
          let data: any[] = [...group.devices];
          data.push(response.device.serial);
          group.devices = data;
          this.groupDevicesDummy(group)

          this.groups.forEach(group => {
            if (group.name !== 'Common' && group.id !== response.device.group.id) {
              let data: any[] = [...group.devices]; // Create a shallow copy
              data = data.filter(num => num !== response.device.serial);
              // let data = group.devices.filter(item => item !== response.device.serial)
              group.devices = data
            }
          });
          this.openAlertMod(this.alertTemplate, response.description)
        },
        error: (e) => {
          this.openAlertMod(this.alertTemplate, e);
        }
      })
    }
    else {
      this.groupsService.addGroupDevice(group.id, device.serial).pipe(first()).subscribe({
        next: (response: any) => {
          if (!response.success &&
            response.status === 409 &&
            response.data.hasOwnProperty('conflicts')) {
            this.groupsEnv[group.id].showConflicts = true
            this.groupsEnv[group.id].conflicts = response.data.conflicts
          }
        },
        error: (e) => {
          this.openAlertMod(this.alertTemplate, e);
        }
      });
    }
  }

  addGroupDevices(group: any, deviceSearch?: any, filteredDevices?: any) {
    let serial: any;
    if (group.class === 'standard') {
      serial = this.groupAvailablestandardizableDevicesList.map((device: any) => { return device.serial }).join();
    }

    this.commonService.isOriginGroup(group.class) ?
      this.devicesService.addOriginGroupDevices(group.id, serial).pipe(first()).subscribe((res: any) => {
        // let presentDeviceInGroup: any[] = this.groupAvailablestandardizableDevicesList;
        // this.standardizableDevices.forEach((device: any) => {
        //     if (presentDeviceInGroup.includes(device.serial)) {
        //       this.groupstandardizableDevicesList.push(device);
        //     }
        //   })
        // this.groupAvailabeDevicesDummy(res.group)
        // this.groupDevicesDummy(res.group)
        //   this.groupAvailablestandardizableDevicesList=[];
        let serialArray = serial.split(',');
        let data: any[] = [...group.devices];
        serialArray.forEach(element => {
          data.push(element);
        });
        group.devices = data;
        this.groupAvailablestandardizableDevicesList = [];
        this.groupDevicesDummy(group)
        this.groups.forEach((item: any) => {
          if (item.id != group.id) {
            group.devices.forEach((element: any) => {
              const index = item.devices.findIndex((device: any) => device.serial === element.serial);
              // If a matching device is found, remove it using splice
              if (index !== -1) {
                item.devices.splice(index, 1);
              }
            })
          }
        })
        this.openAlertMod(this.alertTemplate, res.description);
      }) :
      this.groupsService.addGroupDevices(group.id, serial).pipe(first()).subscribe((res: any) => {
        this.openAlertMod(this.alertTemplate, res.description);
      })
  }

  removeGroupDevice(group: any, device: any) {
    this.commonService.isOriginGroup(group.class) ?
      this.devicesService.removeOriginGroupDevice(group.id, device.serial).pipe(first()).subscribe({
        next: (res: any) => {
          this.openAlertMod(this.alertTemplate, res.description);
          let dummyAarray = this.groupstandardizableDevicesList.filter(item => item.serial !== res.device.serial)

          this.groupstandardizableDevicesList = dummyAarray;
          let removeSerial = this.groupstandardizableDevicesList.filter(myitem => myitem.serial === res.device.serial)
          // group.devices.push(res.device.serial);
          // group.devices.filter(item => item.serial ===res.device.serial)
          this.groups.forEach(mygroup => {
            if (mygroup.id === group.id) {
              let data: any[] = [...mygroup.devices]; // Create a shallow copy
              data = data.filter(num => num !== res.device.serial);

              mygroup.devices = data;
              this.groupAvailabeDevicesDummy(group)
            }
          })
        },
        error: (e) => {
          this.openAlertMod(this.alertTemplate, e);
        }
      }) :
      this.groupsService.removeGroupDevice(group.id, device.serial).pipe(first()).subscribe((res: any) => {
        this.openAlertMod(this.alertTemplate, res.description);
      })
  }

  removeGroupDevices(group: any, deviceSearch?: any, filteredDevices?: any) {
    let serial: any;
    if (group.class === 'standard') {
      serial = this.groupstandardizableDevicesList.map((device: any) => { return device.serial }).join();
    }

    this.commonService.isOriginGroup(group.class) ?
      this.devicesService.removeOriginGroupDevices(group.id, serial).pipe(first()).subscribe((res: any) => {
        let data: any[] = [...group.devices];
        this.standardizableDevices.forEach((device: any) => {
          if (data.includes(device.serial))
            this.groupAvailablestandardizableDevicesList.push(device);
        })
        this.groupstandardizableDevicesList = [];
        group.devices = [];
        this.openAlertMod(this.alertTemplate, res.description);
        // group.forEach((device: any)=>{

        //   this.groupAvailablestandardizableDevicesList.push(device);
        // })


      }) :
      this.groupsService.removeGroupDevices(group.id, serial).pipe(first()).subscribe((res: any) => {
        this.openAlertMod(this.alertTemplate, res.message);
      })
  }

  addGroupUser(group: any, user: any) {
    this.groupsService.addGroupUser(group.id, user.email).pipe(first()).subscribe((res: any) => {
      // this.openAlertMod(this.alertTemplate, res.description);
      group.users.push(user.email)
      let data = this.availableUserList.filter(item => item.email !== user.email)
      this.availableUserList = data
      this.availableUserDummy(group)
      this.groupUserDummy(group)
    });
  }

  addGroupUsers(group: any) {
    let email = this.availableUserList.map((user: any) => { return user.email }).join();
    this.groupsService.addGroupUsers(group.id, email).pipe(first()).subscribe((res: any) => {
      // this.openAlertMod(this.alertTemplate, res.description);
      this.availableUserDummy(res.group)
      this.groupUserDummy(res.group)
    });
  }

  removeGroupUser(group: any, user: any) {
    this.groupsService.removeGroupUser(group.id, user.email).pipe(first()).subscribe((res: any) => {
      this.openAlertMod(this.alertTemplate, res.description);
      if (res.success == 'true' || res.success == true) {
        group.users = res.group.users
      }
      this.groupUserDummy(res.group)
      this.availableUserDummy(res.group)
    });
  }

  removeGroupUsers(group: any) {
    let email = this.groupUserList.map((user: any) => { return user.email }).join();
    this.groupsService.removeGroupUsers(group.id, email).pipe(first()).subscribe((res: any) => {
      this.openAlertMod(this.alertTemplate, res.description);
      this.groupUserDummy(res.group)
      this.availableUserDummy(res.group)
    });
  }

  remove(group?: any) {
    this.groupId = group?.id;
    this.modalRef = this.dialog.open(this.removeGroupTemplate);
  }

  removeGroup() {
    this.groupsService.removeGroup(this.groupId).pipe(first()).subscribe((res: any) => {
      this.initScope();
      this.deleteUser(this.groupId, Date.now())
      this.cancelRequest()
    });
  }

  removeGroups(search?: any, filteredGroups?: any, askConfirmation?: any, removeTemplate?: TemplateRef<any>) {



    this.cancelRequest();
    let removeGroups = () => {

      this.groupsService.removeGroups(null).pipe(first()).subscribe((res: any) => {
        this.openAlertMod(this.alertTemplate, res.description);

        this.groups = this.groups.filter((group) => group.name === "Common");
      })


      // this.groups.forEach(group => {
      //   if (group.class === 'standard') {
      //     // Logic for standard groups
      //   } else {
      //     // Logic for non-standard groups
      //     this.deleteUser(group.id, Date.now())
      //     // .subscribe(
      //     //   () => console.log(`User ${group.id} deleted successfully.`),
      //     //   error => console.error(`Error deleting user ${group.id}:`, error)
      //     // );
      //   }
      // });
      // this.groups.forEach(group => {

      //   if (group.class === 'standard') {



      //   }

      //   else {

      //     this.deleteUser(group.id, Date.now())


      //   }

      // })

      //  for(let i=1;i<this.groups.length;i++)
      //  {
      //   if(this.groups[i].class!=='standard'){
      //     this.deleteUser(this.groups[i].id, Date.now())

      //   }
      //  }
    }

    if (askConfirmation) {
      this.modalRef = this.dialog.open(removeTemplate);
    } else {
      removeGroups()
    }
  }

  createGroup() {
    this.hideGroupCreation = true;
    this.groupsService.createGroup().pipe(first()).subscribe({



      next: (response: any) => {

        if (response.success == true || response.success == "true") {
          this.hideGroupCreation = false;
          this.initScope();
          this.openAlertMod(this.alertTemplate, response.description);

        } else {
          this.openAlertMod(this.alertTemplate, response.description);
        }
      },
      error: (e) => {
        this.openAlertMod(this.alertTemplate, e.error.description);
      }
    });
  }

  updateGroupSchedule(group: any) {
    let data = {
      'class': this.groupsEnv[group.id].tmpClass
      , 'repetitions': parseInt(this.groupsEnv[group.id].tmpRepetitions, 10)
      , 'startTime': new Date(this.groupsEnv[group.id].tmpStartDate).toISOString()
      , 'stopTime': new Date(this.groupsEnv[group.id].tmpStopDate).toISOString()
    };

    this.groupsService.updateGroup(group.id, data).pipe(first()).subscribe({
      next: (response: any) => {




        if (response.success === 'true' || response.success == true) {


          this.disableSavebutton = true;


        }


        this.groups.forEach(group => {
          if (group.id === response.group.id) {

            if (response.group.state === 'ready' && response.group.class === 'standard') {

              group.state = 'ready'
              group.class = 'standard'
              group.isActive = 'true'
            }
            else if (response.group.state === 'ready' && response.group.class === 'bookable') {

              group.state = 'ready'
              group.isActive = 'true'
              group.class = 'bookable'
            }



            //  else if(response.group.state === 'class')


          }
        })

        if (response.group.class === 'standard' || response.group.class === 'bookable') {
          this.disableDropdown = true; // Set dropdownDisabled to true
          this.disableSavebutton = true;
          this.hiddenGetReady = true

        }
        else if (response.group.class === 'once') {
          group.class = 'once'
          group.state = 'pending'

          group.isActive = 'false'
        } else if (response.group.class === 'hourly') {
          group.class = 'hourly'
          group.state = 'pending'
          group.isActive = 'false'

        } else if (response.group.class === 'daily') {
          group.class = 'daily'
          group.state = 'pending'
          group.isActive = 'false'

        } else if (response.group.class === 'weekly') {
          group.class = 'weekly'
          group.state = 'pending'
          group.isActive = 'false'

        } else if (response.group.class === 'monthly') {
          group.class = 'monthly'
          group.state = 'pending'
          group.isActive = 'false'

        } else if (response.group.class === 'quaterly') {
          group.class = 'quaterly'
          group.state = 'pending'
          group.isActive = 'false'

        } else if (response.group.class === 'yearly') {
          group.class = 'yearly'
          group.state = 'pending'
          group.isActive = 'false'

        } else if (response.group.class === 'debug') {
          group.class = 'debug'
          group.state = 'pending'
          group.isActive = 'false'

        }


        if (!response.success &&
          response.status === 409 &&
          response.data.hasOwnProperty('conflicts')) {
          this.groupsEnv[group.id].conflicts = []
          response.data.conflicts.forEach((conflict: any) => {
            conflict.devices.forEach((serial: any) => {
              this.groupsEnv[group.id].conflicts.push({
                serial: serial
                , startDate: moment(conflict.date.start).format(this.settingsService.get('dateFormat'))
                , stopDate: moment(conflict.date.stop).format(this.settingsService.get('dateFormat'))
                , group: conflict.group
                , ownerName: conflict.owner.name
                , ownerEmail: conflict.owner.email
              })
            })
          })
          this.groupsEnv[group.id].showConflicts = true
        }
      },
      error: (e) => {
        this.openAlertMod(this.alertTemplate, e);
      }
    });




  }

  updateGroupState(group: any) {
    this.cancelRequest();
    this.groupsService.updateGroup(group.id, { 'state': 'ready' }).pipe(first()).subscribe((res: any) => {
      if (res.success == true || res.success == "true") {
        this.openAlertMod(this.alertTemplate, res.description);
      }
    });
  }

  updateGroupName(group: any) {
    const duplicateIndex = this.groups.findIndex(existingGroup =>
      existingGroup.name === this.groupsEnv[group.id].tmpName &&
      existingGroup.id !== group.id
    );

    if (duplicateIndex !== -1) {
      this.openAlertMod(this.alertTemplate, "You can't have two groups with same name!")
    } else {
      this.groups[this.groups.findIndex(groups => groups.id == group.id)].name = this.groupsEnv[group.id].tmpName;

      this.groupsService.updateGroup(group.id, { 'name': this.groupsEnv[group.id].tmpName }).pipe(first()).subscribe((res: any) => {
        this.openAlertMod(this.alertTemplate, res.description);
      });
    }
    const myButton = document.getElementById("nameButton");

    if (myButton) {
      myButton.click();
    }
  }




  // <---------------------------------need to check this
  // $scope.$on('user.settings.groups.updated', function(event, message) {
  //   const isChangedSchedule = message.isChangedDates || message.isChangedClass
  //   const doGetDevices =
  //     !CommonService.isOriginGroup(message.group.class) &&
  //     (isChangedSchedule || message.devices.length)
  //   const isGroupOwner = $scope.isAdmin() || $scope.currentUser.email === message.group.owner.email
  //   const group = updateGroup(
  //     message.group
  //   , message.timeStamp
  //   , !isGroupOwner)

  //   if (group) {
  //     if ($scope.isAdmin()) {
  //       if (!CommonService.isOriginGroup(group.class)) {
  //         if (message.devices.length) {
  //           if (!message.isAddedDevice) {
  //             addStandardizableDevicesIfNotBooked(message.devices, message.timeStamp)
  //           }
  //           else {
  //             message.devices.forEach(function(serial) {
  //               deleteStandardizableDevice(serial, message.timeStamp)
  //             })
  //           }
  //         }
  //       }
  //       else if (message.isChangedClass) {
  //         getAvailableGroupDevices(group)
  //       }
  //     }
  //     if (isChangedSchedule && group.state !== 'pending') {
  //       $scope.initTemporarySchedule(group)
  //     }
  //     if (doGetDevices) {
  //       $scope.groups.forEach(function(group) {
  //         if (group.id !== message.group.id || isChangedSchedule) {
  //           getAvailableGroupDevices(group)
  //         }
  //       })
  //     }
  //   }
  //   else if (!isGroupOwner && doGetDevices) { // a completer ... soit propriétaire et event obsolete, soit non propriétaire donc non admin
  //     $scope.groups.forEach(function(group) {
  //       getAvailableGroupDevices(group)
  //     })
  //   }
  // })

  // $scope.$on('user.settings.groups.created', function(event, message) {
  //   addGroup(message.group, message.timeStamp)
  // })

  // $scope.$on('user.settings.groups.deleted', function(event, message) {
  //   const group = message.group

  //   if (deleteGroup(group.id, message.timeStamp)) {
  //     if ($scope.isAdmin() && !CommonService.isOriginGroup(group.class)) {
  //       addStandardizableDevicesIfNotBooked(group.devices, message.timeStamp)
  //     }
  //   }
  //   if (!CommonService.isOriginGroup(group.class) && group.devices.length) {
  //     $scope.groups.forEach(function(group) {
  //       if (!CommonService.isOriginGroup(group.class)) {
  //         getAvailableGroupDevices(group)
  //       }
  //     })
  //   }
  // })

  // $scope.$on('user.settings.users.updated', function(event, message) {
  //   function getGroupClass(id) {
  //     if (CommonService.isExisting(groupsById[id])) {
  //       return Promise.resolve($scope.groups[groupsById[id].index].class)
  //     }
  //     else if (cachedGroupsClass[id]) {
  //       return Promise.resolve(cachedGroupsClass[id])
  //     }
  //     else {
  //       return GroupsService.getGroup(id).then(function(response) {
  //         cachedGroupsClass[id] = response.data.group.class
  //         return cachedGroupsClass[id]
  //       })
  //       .catch(function(error) {
  //         return false
  //       })
  //     }
  //   }

  //   if (($scope.isAdmin() &&
  //        CommonService.isExisting($scope.usersByEmail[message.user.email]) ||
  //        message.user.email === $scope.currentUser.email
  //       ) &&
  //       updateUser(message.user, message.timeStamp) &&
  //       message.groups.length) {

  //     Promise.map(message.groups, function(groupId) {
  //       return getGroupClass(groupId).then(function(_class) {
  //         return !_class || _class === 'bookable'
  //       })
  //     })
  //     .then(function(results) {
  //       if (_.without(results, false).length) {
  //         Promise.map($scope.groups, function(group) {
  //           if (group.owner.email === message.user.email &&
  //               !CommonService.isOriginGroup(group.class)) {
  //             getAvailableGroupDevices(group)
  //           }
  //         })
  //       }
  //     })
  //   }
  // })

  // $scope.$on('user.settings.users.created', function(event, message) {
  //   addUser(message.user, message.timeStamp)
  // })

  // $scope.$on('user.settings.users.deleted', function(event, message) {
  //   deleteUser(message.user.email, message.timeStamp)
  // })

  // $scope.$on('user.settings.devices.deleted', function(event, message) {
  //   if ($scope.isAdmin()) {
  //     deleteOriginDevice(message.device.serial, message.timeStamp)
  //     deleteStandardizableDevice(message.device.serial, message.timeStamp)
  //   }
  //   $scope.groups.forEach(function(group) {
  //     if (!CommonService.isOriginGroup(group.class)) {
  //       deleteAvailableGroupDevice(group.id, message.device.serial, message.timeStamp)
  //     }
  //   })
  // })

  // $scope.$on('user.settings.devices.created', function(event, message) {
  //   const device = publishDevice(message.device)

  //   if ($scope.isAdmin()) {
  //     addOriginDevice(device, message.timeStamp)
  //     addStandardizableDevice(device, message.timeStamp)
  //   }
  // })

  // $scope.$on('user.settings.devices.updated', function(event, message) {
  //   const device = publishDevice(message.device)

  //   if ($scope.isAdmin()) {
  //     updateOriginDevice(device, message.timeStamp)
  //     updateStandardizableDeviceIfNotBooked(device, message.timeStamp)
  //   }
  //   $scope.groups.forEach(function(group) {
  //     if (!CommonService.isOriginGroup(group.class)) {
  //       if (device.group.origin !== message.oldOriginGroupId) {
  //         if ($scope.currentUser.groups.subscribed.indexOf(device.group.origin) > -1) {
  //           getAvailableGroupDevices(group, message.timeStamp)
  //         }
  //         else {
  //           deleteAvailableGroupDevice(group.id, device.serial, message.timeStamp)
  //         }
  //       }
  //       else {
  //         updateAvailableGroupDevice(group.id, device, message.timeStamp, true)
  //       }
  //     }availableUserList
  //   })
  // })


  //New Methods
  availableUser(group: any) {
    this.availableUserList = [];

    if (!this.showAvailableUsers) {
      let presentUserInGroup: any[] = group.users;

      this.users.forEach((user: any) => {
        if (!presentUserInGroup.includes(user.email)) {
          this.availableUserList.push(user);
        }
      })
    }
  }

  groupUser(group: any) {
    this.groupUserList = [];
    if (!this.showGroupUsers) {
      let presentUserInGroup: any[] = group.users;
      this.users.forEach((user: any) => {
        if (presentUserInGroup.includes(user.email)) {
          this.groupUserList.push(user);
        }
      })
    }
  }

  groupDevices(group: any) {
    this.groupstandardizableDevicesList = [];
    if (!this.showGroupDevices) {
      let presentDeviceInGroup: any[] = group.devices;
      this.standardizableDevices.forEach((device: any) => {
        if (presentDeviceInGroup.includes(device.serial)) {
          this.groupstandardizableDevicesList.push(device);
        }
      })
    }
  }

  groupAvailabeDevices(group: any) {
    if (group.class === 'standard') {
      this.groupAvailablestandardizableDevicesList = [];
      if (!this.showAvailableDevices) {
        let presentDeviceInGroup: any[] = group.devices;
        this.standardizableDevices.forEach((device: any) => {
          if (!presentDeviceInGroup.includes(device.serial)) {
            this.groupAvailablestandardizableDevicesList.push(device);
          }
        });
      }
    }
  }

  //pagination 	
  page = 1;
  handlePageChange(event: any) {
    this.page = event.pageIndex + 1;
  }

  // Modals
  openAlertMod(template: TemplateRef<any>, message: any, type?: any) {

    let classOpt: any;
    if (type == "remove") {
      classOpt = null;
    } else {
      classOpt = { width: '300px' };
    }

    this.modalRef = this.dialog.open(template, classOpt);
    this.alertMessage = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.alertMessage = "";
    }, 2000)
  }

  cancelRequest() {
    this.modalRef.close();
    // window.location.reload()
    this.commonService.setActiveTab('/settings');
    this.router.navigate(['settings', 'group']);
  }


  groupAvailabeDevicesDummy(group: any) {
    if (group.class === 'standard') {
      this.groupAvailablestandardizableDevicesList = [];
      let presentDeviceInGroup: any[] = group.devices;
      this.standardizableDevices.forEach((device: any) => {
        if (!presentDeviceInGroup.includes(device.serial)) {
          this.groupAvailablestandardizableDevicesList.push(device);
        }
      }
      )
    }
  }
  groupDevicesDummy(group: any) {


    this.groupstandardizableDevicesList = [];
    let presentDeviceInGroup: any[] = group.devices;
    this.standardizableDevices.forEach((device: any) => {
      if (presentDeviceInGroup.includes(device.serial)) {
        this.groupstandardizableDevicesList.push(device);
      }
    })
  }


  groupUserDummy(group: any) {


    this.groupUserList = [];

    let presentUserInGroup: any[] = group.users;

    this.users.forEach((user: any) => {
      if (presentUserInGroup.includes(user.email)) {
        this.groupUserList.push(user);
      }
    })
    // }

  }


  availableUserDummy(group: any) {
    this.availableUserList = [];

    let presentUserInGroup: any[] = group.users;



    this.users.forEach((user: any) => {
      if (!presentUserInGroup.includes(user.email)) {

        this.availableUserList.push(user);
      }
    })

  }
  initShowBrowsers(group: any) {
    group.isBrowserClicked = !group.isBrowserClicked;
  }

  // Fetch browsers assigned to current group
  groupBrowsers(group: any) {
    const state = this.initializeGroupState(group.id);
    this.groupsService.getBrowsersByGroup(group.id).subscribe({
      next: (response: any) => {
        if (response.success && response.browsers) {
          state.groupBrowsers = response.browsers.map((browser: Browser) => ({
            ...browser,
            selected: false
          }));

          if (group.browsers) {
            group.browsers = response.browsers;
          }
        } else {
          state.groupBrowsers = [];
        }
      },
      error: (error: any) => {
        state.groupBrowsers = [];
        this.openAlertMod(this.alertTemplate, 'Error fetching group browsers');
      }
    });
  }

  // Fetch available browsers that can be added to group
  groupAvailableBrowsers(group: any) {
    const state = this.initializeGroupState(group.id);

    this.groupsService.getNonacquiredBrowsers().subscribe({
      next: (response: any) => {
        if (response.success && response.browsers) {
          state.availableBrowsers = response.browsers.map((browser: Browser) => ({
            ...browser,
            selected: false
          }));
        } else {
          state.availableBrowsers = [];
        }
      },
      error: (error: any) => {
        state.availableBrowsers = [];
        this.openAlertMod(this.alertTemplate, 'Error fetching available browsers');
      }
    });
  }

  // Add single browser to group
  addGroupBrowser(group: any, browser: Browser) {
    const state = this.initializeGroupState(group.id);

    this.groupsService.addGroupBrowser(group.id, browser.id).subscribe({
      next: (response: any) => {
        if (response.success) {
          const browserCopy = { ...browser, selected: false };
          state.groupBrowsers.push(browserCopy);
          state.availableBrowsers = state.availableBrowsers.filter(b => b.id !== browser.id);
          if (group.browsers) {
            group.browsers.push(browser);
          }

          // Success alert
          this.openAlertMod(this.alertTemplate, response.description || 'Browser added to group successfully');
        }
      },
      error: (error: any) => {
        console.error('Error adding browser to group:', error);
        this.openAlertMod(this.alertTemplate, error.error?.message || 'Error adding browser to group');
      }
    });
  }

  // Remove single browser from group
  removeGroupBrowser(group: any, browser: Browser) {
    const state = this.initializeGroupState(group.id);

    this.groupsService.removeGroupBrowser(browser.id).subscribe({
      next: (response: any) => {
        if (response.success) {
          // Remove from group browsers
          state.groupBrowsers = state.groupBrowsers.filter(b => b.id !== browser.id);

          // Add back to available browsers with selection state
          const browserCopy = { ...browser, selected: false };
          state.availableBrowsers.push(browserCopy);

          // Update group's browser array if it exists
          if (group.browsers) {
            group.browsers = group.browsers.filter((b: Browser) => b.id !== browser.id);
          }

          // Success alert
          this.openAlertMod(this.alertTemplate, response.description || 'Browser removed from group successfully');
        }
      },
      error: (error: any) => {
        console.error('Error removing browser from group:', error);
        this.openAlertMod(this.alertTemplate, error.error?.message || 'Error removing browser from group');
      }
    });
  }

  // ==================== BULK OPERATIONS ====================

  // Add multiple browsers to group
  addGroupBrowsers(group: any) {
    const state = this.initializeGroupState(group.id);
    const selectedBrowsers = state.availableBrowsers.filter((browser: any) => browser.selected);

    if (selectedBrowsers.length === 0) {
      this.openAlertMod(this.alertTemplate, 'No browsers selected for addition');
      return;
    }

    const browserIds = selectedBrowsers.map(browser => browser.id);

    // Try bulk API first
    this.groupsService.addGroupBrowsers(group.id, browserIds).subscribe({
      next: (response: any) => {
        if (response.success) {
          // Update UI after bulk addition
          selectedBrowsers.forEach(browser => {
            const browserCopy = { ...browser, selected: false };
            state.groupBrowsers.push(browserCopy);
            state.availableBrowsers = state.availableBrowsers.filter(b => b.id !== browser.id);
          });

          // Update group's browser array if it exists
          if (group.browsers) {
            group.browsers.push(...selectedBrowsers);
          }

          this.clearBrowserSelections(group);
          // Success alert
          this.openAlertMod(this.alertTemplate, response.description || `${selectedBrowsers.length} browsers added to group successfully`);
        }
      },
      error: (error: any) => {
        console.error('Bulk add failed, trying individual additions:', error);
        // Fallback to individual additions
        this.addBrowsersIndividually(group, selectedBrowsers);
      }
    });
  }

  // Remove multiple browsers from group
  removeGroupBrowsers(group: any) {
    const state = this.initializeGroupState(group.id);
    const selectedBrowsers = state.groupBrowsers.filter((browser: any) => browser.selected);

    if (selectedBrowsers.length === 0) {
      this.openAlertMod(this.alertTemplate, 'No browsers selected for removal');
      return;
    }

    const browserIds = selectedBrowsers.map(browser => browser.id);

    // Try bulk API first
    this.groupsService.removeGroupBrowsers(browserIds).subscribe({
      next: (response: any) => {
        if (response.success) {
          // Update UI after bulk removal
          selectedBrowsers.forEach(browser => {
            state.groupBrowsers = state.groupBrowsers.filter(b => b.id !== browser.id);
            const browserCopy = { ...browser, selected: false };
            state.availableBrowsers.push(browserCopy);
          });

          // Update group's browser array if it exists
          if (group.browsers) {
            group.browsers = group.browsers.filter(gb => !selectedBrowsers.some(sb => sb.id === gb.id));
          }

          this.clearBrowserSelections(group);
          // Success alert
          this.openAlertMod(this.alertTemplate, response.description || `${selectedBrowsers.length} browsers removed from group successfully`);
        }
      },
      error: (error: any) => {
        console.error('Bulk remove failed, trying individual removals:', error);
        // Fallback to individual removals
        this.removeBrowsersIndividually(group, selectedBrowsers);
      }
    });
  }

  // ==================== FALLBACK METHODS ====================

  private addBrowsersIndividually(group: any, browsers: Browser[]) {
    const state = this.initializeGroupState(group.id);
    const addPromises = browsers.map(browser => {
      return this.groupsService.addGroupBrowser(group.id, browser.id).toPromise();
    });

    Promise.all(addPromises).then(
      (responses) => {
        // Update UI after all additions are complete
        browsers.forEach(browser => {
          const browserCopy = { ...browser, selected: false };
          state.groupBrowsers.push(browserCopy);
          state.availableBrowsers = state.availableBrowsers.filter(b => b.id !== browser.id);
        });

        // Update group's browser array if it exists
        if (group.browsers) {
          group.browsers.push(...browsers);
        }

        this.clearBrowserSelections(group);
        // Success alert
        this.openAlertMod(this.alertTemplate, `${browsers.length} browsers added to group successfully`);
      }
    ).catch(
      (error) => {
        console.error('Error adding multiple browsers:', error);
        this.openAlertMod(this.alertTemplate, 'Error adding multiple browsers to group');
      }
    );
  }

  private removeBrowsersIndividually(group: any, browsers: Browser[]) {
    const state = this.initializeGroupState(group.id);
    const removePromises = browsers.map(browser => {
      return this.groupsService.removeGroupBrowser(browser.id).toPromise();
    });

    Promise.all(removePromises).then(
      (responses) => {
        // Update UI after all removals are complete
        browsers.forEach(browser => {
          state.groupBrowsers = state.groupBrowsers.filter(b => b.id !== browser.id);
          const browserCopy = { ...browser, selected: false };
          state.availableBrowsers.push(browserCopy);
        });

        // Update group's browser array if it exists
        if (group.browsers) {
          group.browsers = group.browsers.filter(gb => !browsers.some(sb => sb.id === gb.id));
        }

        this.clearBrowserSelections(group);
        // Success alert
        this.openAlertMod(this.alertTemplate, `${browsers.length} browsers removed from group successfully`);
      }
    ).catch(
      (error) => {
        console.error('Error removing multiple browsers:', error);
        this.openAlertMod(this.alertTemplate, 'Error removing multiple browsers from group');
      }
    );
  }

  // Toggle all group browsers selection
  toggleAllGroupBrowsers(group: any, checked: boolean) {
    const state = this.initializeGroupState(group.id);
    state.groupBrowsers.forEach((browser: any) => {
      browser.selected = checked;
    });
  }

  // Toggle all available browsers selection
  toggleAllAvailableBrowsers(group: any, checked: boolean) {
    const state = this.initializeGroupState(group.id);
    state.availableBrowsers.forEach((browser: any) => {
      browser.selected = checked;
    });
  }

  // Clear all selections for a group
  private clearBrowserSelections(group: any): void {
    const state = this.initializeGroupState(group.id);
    state.groupBrowsers.forEach((browser: any) => browser.selected = false);
    state.availableBrowsers.forEach((browser: any) => browser.selected = false);
  }

  // ==================== PAGINATION METHODS ====================

  // Handle search input for group browsers
  onBrowserSearch(group: any, searchTerm: string) {
    const state = this.initializeGroupState(group.id);
    state.browserSearch = searchTerm;
    state.browserCurrentPage = 1;
  }

  onBrowserItemPerPageChange(group: any, pageSize: number) {
    const state = this.initializeGroupState(group.id);
    state.groupBrowserPageSize = pageSize;
    state.browserCurrentPage = 1;
  }

  onNextBrowserPageChange(group: any, page: number) {
    const state = this.initializeGroupState(group.id);
    state.browserCurrentPage = page;
  }

  onAvailableBrowserSearch(group: any, searchTerm: string) {
    const state = this.initializeGroupState(group.id);
    state.availableBrowserSearch = searchTerm;
    state.availableBrowserCurrentPage = 1;
  }

  onAvailableBrowserItemPerPageChange(group: any, pageSize: number) {
    const state = this.initializeGroupState(group.id);
    state.availableBrowserPageSize = pageSize;
    state.availableBrowserCurrentPage = 1;
  }

  onNextAvailableBrowserPageChange(group: any, page: number) {
    const state = this.initializeGroupState(group.id);
    state.availableBrowserCurrentPage = page;
  }

  sortByGroupBrowsers(group: any, browserData: any, column: any) {
    const state = this.initializeGroupState(group.id);

    browserData.columns.forEach((col: any) => {
      if (col !== column) {
        col.sort = 'none';
      }
    });

    if (column.sort === 'none' || column.sort === 'sort-desc') {
      column.sort = 'sort-asc';
      state.sortDirectionGrpBrowsers = 'asc';
    } else {
      column.sort = 'sort-desc';
      state.sortDirectionGrpBrowsers = 'desc';
    }

    switch (column.name) {
      case 'ID':
        state.sortFieldGrpBrowsers = 'id';
        break;
      case 'Browser':
        state.sortFieldGrpBrowsers = 'browser';
        break;
      case 'Browser Version':
        state.sortFieldGrpBrowsers = 'browserVersion';
        break;
      case 'OS':
        state.sortFieldGrpBrowsers = 'os';
        break;
      case 'IP':
        state.sortFieldGrpBrowsers = 'ip';
        break;
      case 'Port':
        state.sortFieldGrpBrowsers = 'port';
        break;
      case 'Username':
        state.sortFieldGrpBrowsers = 'username';
        break;
      case 'Access URL':
        state.sortFieldGrpBrowsers = 'accessUrl';
        break;
      case 'Automation URL':
        state.sortFieldGrpBrowsers = 'automationUrl';
        break;
      case 'Automation Port':
        state.sortFieldGrpBrowsers = 'automationPort';
        break;
      case 'NGASA URL':
        state.sortFieldGrpBrowsers = 'ngasa_url';
        break;
      default:
        state.sortFieldGrpBrowsers = 'id';
    }

    browserData.sort.class = 'grp';
  }

  sortByAvailableBrowsers(group: any, browserData: any, column: any) {
    const state = this.initializeGroupState(group.id);

    browserData.columns.forEach((col: any) => {
      if (col !== column) {
        col.sort = 'none';
      }
    });

    if (column.sort === 'none' || column.sort === 'sort-desc') {
      column.sort = 'sort-asc';
      state.sortDirectionAvlBrowsers = 'asc';
    } else {
      column.sort = 'sort-desc';
      state.sortDirectionAvlBrowsers = 'desc';
    }

    switch (column.name) {
      case 'ID':
        state.sortFieldAvlBrowsers = 'id';
        break;
      case 'Browser':
        state.sortFieldAvlBrowsers = 'browser';
        break;
      case 'Browser Version':
        state.sortFieldAvlBrowsers = 'browserVersion';
        break;
      case 'OS':
        state.sortFieldAvlBrowsers = 'os';
        break;
      case 'IP':
        state.sortFieldAvlBrowsers = 'ip';
        break;
      case 'Port':
        state.sortFieldAvlBrowsers = 'port';
        break;
      case 'Username':
        state.sortFieldAvlBrowsers = 'username';
        break;
      case 'Access URL':
        state.sortFieldAvlBrowsers = 'accessUrl';
        break;
      case 'Automation URL':
        state.sortFieldAvlBrowsers = 'automationUrl';
        break;
      case 'Automation Port':
        state.sortFieldAvlBrowsers = 'automationPort';
        break;
      case 'NGASA URL':
        state.sortFieldAvlBrowsers = 'ngasa_url';
        break;
      default:
        state.sortFieldAvlBrowsers = 'id';
    }

    browserData.sort.class = 'avl';
  }

  showBrowserGrpmenu(group: any) {
    const state = this.initializeGroupState(group.id);
    state.showBrowserGrpMenu = !state.showBrowserGrpMenu;

    state.showBrowserAvlMenu = false;
  }

  showBrowserAvlmenu(group: any) {
    const state = this.initializeGroupState(group.id);
    state.showBrowserAvlMenu = !state.showBrowserAvlMenu;
    state.showBrowserGrpMenu = false;
  }

  resetBrowserData() {
    this.defaultBrowserData = JSON.parse(JSON.stringify({
      columns: [
        { name: 'ID', selected: true, sort: 'sort-asc' },
        { name: 'Browser', selected: true, sort: 'none' },
        { name: 'Browser Version', selected: true, sort: 'none' },
        { name: 'OS', selected: true, sort: 'none' },
        { name: 'IP', selected: true, sort: 'none' },
        { name: 'Port', selected: true, sort: 'none' },
        { name: 'Username', selected: true, sort: 'none' },
        { name: 'Access URL', selected: false, sort: 'none' },
        { name: 'Automation URL', selected: false, sort: 'none' },
        { name: 'Automation Port', selected: false, sort: 'none' },
        { name: 'NGASA URL', selected: false, sort: 'none' }
      ],
      sort: { class: '', index: 0, reverse: false }
    }));

    this.browserData = { ...this.defaultBrowserData };
  }

  hasSelectedGroupBrowsers(group: any): boolean {
    const state = this.initializeGroupState(group.id);
    return state.groupBrowsers.some((browser: any) => browser.selected);
  }

  hasSelectedAvailableBrowsers(group: any): boolean {
    const state = this.initializeGroupState(group.id);
    return state.availableBrowsers.some((browser: any) => browser.selected);
  }

  getSelectedGroupBrowsersCount(group: any): number {
    const state = this.initializeGroupState(group.id);
    return state.groupBrowsers.filter((browser: any) => browser.selected).length;
  }

  getSelectedAvailableBrowsersCount(group: any): number {
    const state = this.initializeGroupState(group.id);
    return state.availableBrowsers.filter((browser: any) => browser.selected).length;
  }


  //   onChange(data :any){

  //   //  (data.target.value  !== this.groupsEnv[group.id].tmpClass) }

  // }
}